import { render, staticRenderFns } from "./WorkingHoursAbsences.vue?vue&type=template&id=7971112e&scoped=true&"
import script from "./WorkingHoursAbsences.vue?vue&type=script&lang=js&"
export * from "./WorkingHoursAbsences.vue?vue&type=script&lang=js&"
import style0 from "./WorkingHoursAbsences.vue?vue&type=style&index=0&id=7971112e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7971112e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VIcon,VSnackbar})
